import { useLazyQuery } from '@apollo/client/react';
import { LIST_CASES } from '../queries/ListCases';

import { LoggerContextProps } from '../types/LogContext';
import { Case } from '../types/Case';
import { UseHookOptions } from '../types/UseHookOptions';
import { handleError } from './errorHandler';

export function useListCases(options: UseHookOptions = {}) {
  const context: LoggerContextProps = {
    action: 'listCases',
  };
  const { useCache = true } = options;
  const [listCasesQuery, { data, loading, error, refetch }] = useLazyQuery<{
    listCases: {
      items: Case[];
    };
  }>(LIST_CASES, {
    fetchPolicy: useCache ? 'cache-and-network' : 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  const listCases = async () => {
    try {
      await listCasesQuery();
    } catch (error) {
      handleError(error, context, `Failed to list cases.`, `Failed to list cases:`);
    }
  };

  return {
    listCases,
    refetch,
    data,
    loading,
    error,
  };
}
